import React from 'react';

class VpnTable extends React.Component {
  render = () => {
    return (
      <table>
        <tr>
          <th>VPN Name</th>
          <th>VPN Type</th>
          <th>IP</th>
        </tr>
        <tr>
          <td>Test</td>
          <td>OpenVPN</td>
          <td>1.2.3.4</td>
        </tr>
      </table>
    );
  }
}

export default VpnTable;



// WEBPACK FOOTER //
// ./src/VpnTable.js